module.exports = __webpack_public_path__ + "assets/img/bh1.f0569247.jpg";